import * as React from "react";

import { Popup } from "@progress/kendo-react-popup";
import { ListView, ListViewFooter } from "@progress/kendo-react-listview";
import { Avatar } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";

let contacts = [
  {
    message: "Weighbridge maintenance is due.",
  },
  {
    message: "Upgrade to premium",
  },
];

export const Alert = () => {
  const anchor = React.useRef(null);
  const [show, setShow] = React.useState(false);

  const MyHeader = () => {};
  const MyFooter = () => {
    let messages = 0;
    contacts.map((i) => {
      messages = messages + i.messages;
    });
    return (
      <ListViewFooter
        style={{
          color: "black",
          fontSize: 19,
        }}
      >
        <div>
          <Button type={"submit"} className="mark-button">
            Mark all as read
          </Button>
        </div>
      </ListViewFooter>
    );
  };
  const MyItemRender = (props) => {
    let item = props.dataItem;
    return (
      <div
        className="row p-2 border-bottom align-middle"
        style={{
          margin: 0,
        }}
      >
        <div className="col-2 avatar-container">
          <Avatar type="img">
            <img src="wms.ico" alt="name" />
          </Avatar>
        </div>
        <div className="col-10 message-container">
          <h1
            style={{
              fontSize: 14,
              color: "black",
              marginBottom: 0,
            }}
          >
            {item.message}
          </h1>
          <h2
            style={{
              fontSize: 14,
              color: "black",
              marginBottom: 0,
            }}
          >
            {item.additionalText}
          </h2>
        </div>
      </div>
    );
  };

  const onClick = () => {
    setShow(!show);
  };
  return (
    <div>
      <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
        onClick={onClick}
        ref={anchor}
      >
        <span className="k-icon k-i-notification"></span>
      </button>
      <Popup anchor={anchor.current} show={show} popupClass={"popup-content"}>
        <ListView
          data={contacts}
          item={MyItemRender}
          style={{
            width: "100%",
          }}
          header={MyHeader}
          footer={MyFooter}
        />
      </Popup>
    </div>
  );
};
